import type { IconSvgObject } from './types';

const ChartRelationshipIcon: IconSvgObject = [
  ["path", { d: "M11 5L18 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 10L14.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 11L5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "4.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "5", cy: "20", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["circle", { cx: "16", cy: "16", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }],
  ["circle", { cx: "20", cy: "5", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "6" }]
];

export default ChartRelationshipIcon;
